// IE11 polyfills - although still throwing a page breaking error "Object doesn't support property or method 'repeat'"
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js/features/string/repeat';
////////////

import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";


if (process.env.NODE_ENV !== "production") {
  require("./stubs");
}

ReactDOM.render(<App />, document.getElementById("pen-stand-root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
